/**
 * Системні коди статусів справи — копія enum беку
 * `backend/web/src/Containers/DictionaryContainer/Database/Enum/ActivityStatusCode.php`
 * (`SPEC-007` §3.3). Назву й колір адміністратор змінює в довіднику, логіка
 * (прострочення, «Завершити справу») дивиться лише на код.
 *
 * Значення звіряє вартовий В-6 (`Ship/Helpers/architectureGuard.test.ts`).
 */
export const ACTIVITY_STATUS_CODES = {
    new: 'activity-new',
    completed: 'activity-completed',
} as const

export type ActivityStatusCode = (typeof ACTIVITY_STATUS_CODES)[keyof typeof ACTIVITY_STATUS_CODES]
